import createPageConstants from '../shared/util/createPageConstants';
const pluginId = 'new-maps';
const typeName = 'Maps';
export const MapsConstants = createPageConstants(pluginId, 'Maps', {
  defaultDefault: 'default',
  editor: 'mapsDetailPage',
  typeName,
  pluginId,
});
